// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RyUj","content":"styles_content__3uvTY","footText":"styles_footText__32JZh"};